<template>
    <div>
        <el-dialog v-if="dialogVisible" v-el-drag-dialog :title="$tx('hygl.components.selectMeeting', '选择议题')" :visible.sync="dialogVisible" width="1100px" :close-on-click-modal="false" :destroy-on-close="true" @close="toClose">
            <div>
                <div class="dialog_top">
                    <el-select v-model="searchObj.type" style="margin-right: 15px" size="small" :placeholder="$tx('hygl.hyyt.pleaseSelect', '请选择')">
                        <el-option v-for="item in typeOptions" :key="item.value" :label="item.text" :value="item.value"></el-option>
                    </el-select>
                    <el-input v-model="searchObj.title" style="width: 250px" size="small" :placeholder="$tx('hygl.hyyt.pleaseIput', '请输入')"></el-input>
                    <el-button type="primary" size="small" icon="el-icon-search" @click="searchHandle"></el-button>
                </div>
                <el-table ref="table" v-loading="loading" :data="tableData" border class="jxzb-tables" @selection-change="selectionChange" @sort-change="tableSort">
                    <el-table-column type="selection" width="50" align="center"></el-table-column>
                    <el-table-column type="index" :label="$tx('fields.index', '序号')" width="50" align="center"></el-table-column>
                    <el-table-column prop="subject" :label="$tx('hygl.components.meetingAgenda', '会议议题')" :show-overflow-tooltip="true"></el-table-column>
                    <!-- <el-table-column prop="subjectTypeName" :label="$tx('hygl.components.meetingType', '会议类型')" width="120" align="center" :show-overflow-tooltip="true"></el-table-column> -->
                    <el-table-column prop="mainDept" :label="$tx('hygl.components.hostDepartment', '主办部门')" width="120" align="center" :show-overflow-tooltip="true"></el-table-column>
                    <el-table-column prop="reportPersonName" :label="$tx('hygl.components.declarant', '陈述人')" width="120" align="center" :show-overflow-tooltip="true"></el-table-column>
                    <el-table-column prop="reportTime" :label="$tx('hygl.components.csTime', '陈述时间/分钟')" width="110" :show-overflow-tooltip="true" align="center"></el-table-column>
                    <el-table-column prop="talkTime" :label="$tx('hygl.components.talkTime', '讨论时间/分钟')" width="110" :show-overflow-tooltip="true" align="center"></el-table-column>
                    <el-table-column prop="attendDept" :label="$tx('hygl.components.attendDept', '列席部门')" width="200" :show-overflow-tooltip="true" align="left"></el-table-column>
                    <!-- <el-table-column prop="generateType" label="议题来源" width="100" :show-overflow-tooltip="true" align="center"></el-table-column> -->
                    <el-table-column prop="createDate" :label="$tx('hygl.ytRecord.createDate', '创建时间')" width="130" :show-overflow-tooltip="true" align="center" sortable="custom">
                        <template slot-scope="scope">
                            <span>{{ scope.row.createDate | timeFormat }}</span>
                        </template>
                    </el-table-column>
                    <!-- <el-table-column prop="endTime" label="征集结束时间" width="130" :show-overflow-tooltip="true" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.endTime |timeFormat }}</span>
            </template>
          </el-table-column> -->
                    <!-- <el-table-column prop="attachCount" label="附件数" width="80" :show-overflow-tooltip="true" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.passenger.attachCount | '无' }}</span>
            </template>
          </el-table-column> -->
                </el-table>
                <div style="display: flex; justify-content: space-between; align-items: center; margin-top: 15px">
                    <!-- <div v-if="tyDirectory.length" class="yt_ml">
                        <span v-text-lbl="'hygl.components.selectDirId'">归属会议目录：</span>
                        <el-select v-model="selectDirId" style="margin-right: 15px" size="small" :placeholder="$tx('hygl.hyyt.pleaseSelect', '请选择')">
                            <el-option v-for="item in tyDirectory" :key="item.text" :label="item.text" :value="item.id"></el-option>
                        </el-select>
                    </div>
                    <div v-else style="width: 50px"></div> -->
                    <div class="page_info">
                        <el-pagination :current-page="currentPage" :page-sizes="[10, 20, 50, 100]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total" @size-change="handleSizeChange" @current-change="handleCurrentChange"></el-pagination>
                    </div>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button v-pageBtn-lbl="'close'" @click="toClose">关 闭</el-button>
                <el-button v-pageBtn-lbl="'save'" type="primary" @click="submitHandle">保 存</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
const moment = require('moment')
export default {
    filters: {
        timeFormat(val) {
            if (val) {
                return moment(val).format('YYYY-MM-DD HH:mm')
            } else {
                return ''
            }
        }
    },
    components: {},
    props: {},
    data() {
        return {
            dialogVisible: false,
            searchObj: {
                type: '',
                title: '',
                key: ''
            },
            selectDirId: '',
            loading: false,
            selectList: [],
            typeOptions: [
                // { label: this.$tx('hygl.hyyt.pleaseSelect', '请选择'), value: '' }
                // { label: this.$tx('hygl.components.xbRoom', '校长办公会'), value: '校长办公会' },
                // { label: this.$tx('hygl.components.otherConferences', '其他全校性大会'), value: '其他全校性大会' }
            ],
            currentRow: {},
            currentList: [],
            currentPage: 1,
            tyDirectory: [], // 议题目录
            pageSize: 10,
            total: 0,
            sortOrder: 'desc'
        }
    },
    computed: {},
    watch: {},
    created() {
        this.$bus.on('openYtRecordDialog', this.openYtRecordDialog)
    },
    beforeDestroy() {
        this.$bus.off('openYtRecordDialog', this.openYtRecordDialog)
    },
    mounted() {},
    methods: {
        openYtRecordDialog(row, list, key = '', ytList = []) {
            console.log('row===', row)
            this.typeOptions = row.passenger.meetingTypeNameOptions
            this.currentRow = row
            this.currentList = list
            this.tyDirectory = ytList
            console.log('this.tyDirectory', this.tyDirectory)

            this.searchObj = {
                type: '',
                title: '',
                key: ''
            }
            if (this.tyDirectory.length) {
                this.selectDirId = this.tyDirectory[0].id
            }
            if (key) {
                this.searchObj.key = key
            }
            this.currentPage = 1
            this.pageSize = 10
            this.selectList = []
            this.getTableData()
        },
        async getTableData() {
            this.loading = true
            const ids = []
            if (this.searchObj.key) {
                this.currentList.forEach((item) => {
                    ids.push(item[this.searchObj.key])
                })
            } else {
                this.currentList.forEach((item) => {
                    ids.push(item.ytRecordId)
                })
            }

            const data = {
                pageNum: this.currentPage,
                pageSize: this.pageSize,
                searchAndOr: 'or',
                searchMap: {
                    subject: this.searchObj.title,
                    mainDept: this.searchObj.title,
                    reportPersonName: this.searchObj.title,
                    attendDept: this.searchObj.title
                },
                orderBy: 'createDate ' + this.sortOrder
                // listviewurl: `hygl.ytRecord.list`,
            }
            if (this.searchObj.key) {
                if (ids.length > 0) {
                    data.urlsearch = `${this.searchObj.key}!:${ids.join(',')};status:0`
                } else {
                    data.urlsearch = `status:0`
                }
            } else {
                data.urlsearch = `id!:${ids.join(',')};status:0`
            }
            if (this.searchObj.type) {
                data.urlsearch += `;subjectTypeName:${this.searchObj.type}`
            }
            const res = await this.$app.listdata('hygl/ytRecord/listdata', data)
            if (res.code === 'success') {
                this.tableData = res.body.pageInfo.list

                this.total = res.body.pageInfo.total
            }
            this.dialogVisible = true
            this.loading = false
        },
        selectionChange(val) {
            this.selectList = val
        },
        // 搜索
        searchHandle() {
            this.getTableData()
        },
        // 排序
        tableSort(prop) {
            if (prop.order === 'ascending') {
                this.sortOrder = 'asc'
            } else {
                this.sortOrder = 'desc'
            }
            this.getTableData()
        },
        // 确认
        submitHandle() {
            // if (!this.selectList.length) {
            //     this.$message({ message: '请选择议题。', type: 'warning' })
            //     return
            // }
            // this.$http({
            //     contentType: 'application/x-www-form-urlencoded',
            //     url: `/hygl/ytRecord/adYtSubmitted`,
            //     method: 'POST',
            //     data: this.selectList
            // }).then(res => {
            //     if (res.code === 'success') {
            //         this.$message.success('保存成功。')
            //         this.$bus.emit('refreshListData')
            //         this.dialogVisible = false
            //     } else {
            //         this.$message.error(res.message)
            //     }
            //     this.loading = false
            // })
            console.log('this.tyDirectory', this.tyDirectory)
            console.log('this.selectList', this.selectList)
            console.log('this.searchObj.key', this.searchObj.key)

            if (!this.selectList.length) {
                this.$message.warning('请选择议题！')
                return
            }
            if (this.tyDirectory.length && this.searchObj.key) {
                if (!this.selectDirId) return this.$message.warning(this.$tx('hygl.components.selectDirIdEmpty', '请选择归属会议目录！'))
                this.$emit('selectSubmit', this.selectList, this.selectDirId, () => {
                    this.dialogVisible = false
                })
            } else if (this.searchObj.key) {
                this.$emit('selectSubmit', this.selectList, () => {
                    this.dialogVisible = false
                })
            } else {
                this.$emit('selectSubmit', this.selectList, () => {
                    this.dialogVisible = false
                })
            }
        },
        handleSizeChange(val) {
            this.pageSize = val
            this.getTableData()
        },
        handleCurrentChange(val) {
            this.currentPage = val
            this.getTableData()
        },
        // 关闭
        toClose() {
            this.loading = false
            this.tableData = []
            this.searchObj = {
                dept: '',
                title: ''
            }
            this.dialogVisible = false
        }
    }
}
</script>

<style scoped lang="scss">
.dialog_top {
    display: flex;
    align-items: center;
    margin-bottom: 15px;
    .el-button {
        margin-left: 10px;
        padding: 8px 15px;
    }
}
.jxzb-tables /deep/ .el-table__body-wrapper {
    /* 设置滚动条thumb（滑块）的颜色 */
    &::-webkit-scrollbar-thumb {
        background-color: #d2d4da;
        border-radius: 6px;
    }

    /* 增加滚动条的宽度，高度 */
    &::-webkit-scrollbar {
        width: 6px;
        height: 9px;
    }

    /* 设置滚动条hover时thumb的颜色 */
    &::-webkit-scrollbar-thumb:hover {
        background-color: #d2d4da;
        cursor: pointer;
    }
}
</style>
